<template>
    <div class="px-2">
        <v-toolbar flat>
            <v-toolbar-title><b>Privacy Policy</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="custom-bg_locfeed">
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        v-model="textprivacyPolicy"
                        name="input-7-1"
                        auto-grow
                        value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                    ></v-textarea>
                    <v-btn
                        v-on:click="addprivacyPolicy()"
                        color="primary"
                        block
                    >
                        Submit
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import url1 from "../../../config.js";

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/");
                }
            }, 0);
        });
    },
    name: "TermsAndCondition",
    data() {
        return {
            textprivacyPolicy: "",
            url: url1.url
        };
    },

    methods: {
        getprivacyPolicy() {
            axios
                .get(
                    this.url+"/api/acknowledgement/acknowledgements"
                )
                .then(
                    res => {
                        console.log(res.data.acknowledgment[0].PrivacyNotices);
                        this.textprivacyPolicy =
                            res.data.acknowledgment[0].PrivacyNotices;
                    },
                    err => {
                        console.log(err);
                    }
                )
                .catch(err => {
                    console.error(err.response.data);
                });
        },
        addprivacyPolicy() {
            if (this.textTermsAndCondtions == "") {
                alert("please add some data!");
            } else {
                axios
                    .post(
                        this.url+"/api/acknowledgement/acknowledgements",
                        {
                            About: "",
                            TermOfUse: "",
                            PrivacyNotices: this.textprivacyPolicy
                        },
                        {
                            headers: { "x-auth-token": this.auth.token }
                        }
                    )
                    .then(res => {
                        console.log("text", res);
                    })
                    .catch(err => console.error(err.response.data));
            }
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    mounted() {
        this.getprivacyPolicy();
    }
};
</script>

<style scoped>
.theme--light.v-card {
    background: white;
    border: 0;
}
.custom-bg_locfeed {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
</style>
